export enum AuctionUserType {
  buyer = 0,
  auctioneer = 1,
  administrator = 2
}
